<wsb-modal
  class="custom-modal-width"
  cancelButtonEnable="true"
  (close)="activeModal.close()"
  (dismiss)="activeModal.dismiss()"
  title="{{ 'rich_sms_bootbox_header' | translate }}"
  primaryButtonText="common_send"
  (primary)="isSubscribed ? insertPlaceH() : goToShop()"
  primaryButtonText="{{ isSubscribed ? 'common_send' : 'rich_sms_not_linktest' }}"
  [primaryDisabled]="primaryDisabled()"
>
  <div body *ngIf="isSubscribed">
    <p translate>rich_sms_bootbox_header_helper</p>
    <div>
      <div class="d-flex align-items-center">
        <div class="w-100">
          <label class="radio-custom">
            <input type="radio" [formControl]="fc" [value]="true" />
            <span class="radio-custom__radio"></span>
            <span class="radio-custom__label" translate>rich_sms_bootbox_direct_url</span>
          </label>
          <span *ngIf="fc.value" class="custom-label" translate>rich_sms_bootbox_url_label</span>
          <input
            *ngIf="fc.value"
            type="text"
            class="form-control custom"
            [formControl]="url"
            placeholder="{{ 'rich_sms_bootbox_url_placeholder' | translate }}"
          />

          <label class="radio-custom">
            <input type="radio" [formControl]="fc" [value]="false" />
            <span class="radio-custom__radio"></span>
            <span class="radio-custom__label" translate>rich_sms_bootbox_addressbook</span>
          </label>
          <span *ngIf="fc.value === false" class="custom-label" translate>rich_sms_bootbox_addressbook_label</span>
        </div>
      </div>
    </div>
  </div>

  <div body *ngIf="!isSubscribed">
    <p translate>rich_sms_not_info</p>
  </div>
</wsb-modal>
